import { Device } from './device';

export class VehicleDevices {
    constructor(
      public sideNumber: string,
      public devices: Device[]
    ) {}
}
